import * as React from "react";
import { I18n } from "@lingui/react";
import {
  SecondaryNav,
  SecondaryNavItem,
  Thirds,
  Center,
} from "@conserveit/blocks";
import { getMonitoringTitle } from "../../../scenes/Analysis/Monitoring";
import { Category } from "../utils/types";

interface Props {
  category: string;
  onChangeCategory(category: Category): void;
}

export const SubNav: React.FunctionComponent<Props> = ({
  category,
  onChangeCategory,
}) => (
  <I18n>
    {({ i18n }) => (
      <SecondaryNav hasBottomBorder>
        <Thirds>
          <Center>
            <SecondaryNavItem
              onClick={() => onChangeCategory(Category.All)}
              isActive={category === Category.All}
            >
              {getMonitoringTitle(i18n, Category.All)}
            </SecondaryNavItem>
            <SecondaryNavItem
              onClick={() => onChangeCategory(Category.Connectivity)}
              isActive={category === Category.Connectivity}
            >
              {getMonitoringTitle(i18n, Category.Connectivity)}
            </SecondaryNavItem>
            <SecondaryNavItem
              onClick={() => onChangeCategory(Category.Metering)}
              isActive={category === Category.Metering}
            >
              {getMonitoringTitle(i18n, Category.Metering)}
            </SecondaryNavItem>
            <SecondaryNavItem
              onClick={() => onChangeCategory(Category.Performance)}
              isActive={category === Category.Performance}
            >
              {getMonitoringTitle(i18n, Category.Performance)}
            </SecondaryNavItem>
            <SecondaryNavItem
              onClick={() => onChangeCategory(Category.Comfort)}
              isActive={category === Category.Comfort}
            >
              {getMonitoringTitle(i18n, Category.Comfort)}
            </SecondaryNavItem>
            <SecondaryNavItem
              onClick={() => onChangeCategory(Category.Other)}
              isActive={category === Category.Other}
            >
              {getMonitoringTitle(i18n, Category.Other)}
            </SecondaryNavItem>
          </Center>
        </Thirds>
      </SecondaryNav>
    )}
  </I18n>
);
